// src/App.js
import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { auth } from './firebaseConfig';
import { api, EVENTO_BLOQUEIO } from './api';
import { BuscaSelect, linkWhatsApp, abrirWhatsApp } from './ui';
import { useColecao, recarregar, encerrarDados, iniciarDados } from './dados';
import { onAuthStateChanged, signOut, signInWithEmailAndPassword } from "firebase/auth";

// --- TELAS ---
import ConsultorCadastro from './ConsultorCadastro';
import EmpresaCadastro from './EmpresaCadastro';
import ModuloCadastro from './ModuloCadastro';
import UsuarioCadastro from './UsuarioCadastro';
import PendenciaCadastro from './PendenciaCadastro';
import PendenciasConcluidasView from './PendenciasConcluidasView';
import DashboardConcluidas from './DashboardConcluidas';
import CalendarioView from './CalendarioView';
import ImportarFirebase from './ImportarFirebase';

// --- ÍCONES ---
const Svg = ({ className = 'h-5 w-5', children }) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">{children}</svg>
);
const ClipboardIcon = (p) => <Svg {...p}><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" /></Svg>;
const CalendarIcon = (p) => <Svg {...p}><path d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></Svg>;
const BriefcaseIcon = (p) => <Svg {...p}><path d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></Svg>;
const BuildingIcon = (p) => <Svg {...p}><path d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" /></Svg>;
const CubeIcon = (p) => <Svg {...p}><path d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" /></Svg>;
const SearchIcon = (p) => <Svg {...p}><path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></Svg>;
const ChartIcon = (p) => <Svg {...p}><path d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" /></Svg>;
const LogoutIcon = (p) => <Svg {...p}><path d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" /></Svg>;
const ClockIcon = (p) => <Svg {...p}><path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></Svg>;
const PencilIcon = (p) => <Svg {...p}><path d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" /></Svg>;
const UserIcon = ({ className = 'h-4 w-4' }) => <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" /></svg>;
const WhatsAppIcon = () => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className="h-3.5 w-3.5 inline-block mr-1" fill="currentColor"><path d="M380.9 97.1C339.2 55.4 283.4 32 224 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111l-29.5 101.4c-1.4 5.1.7 10.7 5.7 12.1 1.6.4 3.3.6 5 .6 4.6 0 8.9-2 11.8-5.3l37.9-52.5c27.1 12.3 57.3 18.9 88.5 18.9 122.4 0 222-99.6 222-222 0-53.1-18.3-102.7-50.5-138.9zM224 416c-32.5 0-62.7-8.9-88.8-24.4l-6.3-3.7-40.7 56.4 15.9-54.9-3.7-6.3c-15.5-26.1-24.4-56.3-24.4-88.8 0-101.4 82.3-183.6 183.6-183.6 50.1 0 97.4 19.5 133.5 55.6 36.1 36.1 55.6 83.4 55.6 133.5 0 101.4-82.3 183.6-183.6 183.6z"/></svg>;

// --- CONSTANTES ---
const ItemTypes = { CARD: 'card' };

// Colunas do quadro (as concluídas não são carregadas aqui; ficam na aba "Concluídas")
const COLUNAS = ['Pendente', 'Ag. Retorno', 'Em Atendimento', 'Ag. Pendencia', 'Atualizar'];

const STATUS_COLORS = {
    'Pendente': { bg: 'bg-red-500', border: 'border-red-700', text: 'text-white' },
    'Ag. Retorno': { bg: 'bg-orange-400', border: 'border-orange-600', text: 'text-white' },
    'Em Atendimento': { bg: 'bg-blue-500', border: 'border-blue-700', text: 'text-white' },
    'Ag. Pendencia': { bg: 'bg-yellow-500', border: 'border-yellow-700', text: 'text-black' },
    'Atualizar': { bg: 'bg-purple-500', border: 'border-purple-700', text: 'text-white' },
    'Concluído': { bg: 'bg-green-500', border: 'border-green-700', text: 'text-white' },
};

// Largura das colunas do quadro (cards e títulos usam a mesma)
// Encolhem até 11rem para as 5 colunas caberem em telas menores (1280, 1366, zoom de 125%)
const LARGURA_COLUNA = 'flex-1 min-w-[11rem] max-w-[22rem]';

const TABS = [
    { view: 'pendencias', label: 'Pendências', Icon: ClipboardIcon },
    { view: 'calendario', label: 'Calendário', Icon: CalendarIcon },
    { view: 'consultor', label: 'Consultores', Icon: BriefcaseIcon, soAdmin: true },
    { view: 'empresas', label: 'Empresas', Icon: BuildingIcon, soAdmin: true },
    { view: 'modulos', label: 'Módulos', Icon: CubeIcon, soAdmin: true },
    { view: 'pendencias_concluidas', label: 'Concluídas', Icon: SearchIcon },
    { view: 'dashboard', label: 'Dashboard', Icon: ChartIcon },
];

const hojeTxt = () => new Date().toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
const agoraTxt = () => new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit' });

// Texto para busca: minúsculo e sem acentos
const normalizar = (s) => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

// Data de abertura da pendência: usa o timestamp; se não houver, lê o texto "dd/mm/aaaa"
const dataAbertura = (task) => {
    if (task.timestampCriacao && typeof task.timestampCriacao.toDate === 'function') return task.timestampCriacao.toDate();
    const m = String(task.dtLancamento || '').match(/(\d{2})\/(\d{2})\/(\d{4})/);
    if (!m) return null;
    const [h, mi] = String(task.hora || '00:00').split(':').map(Number);
    return new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1]), h || 0, mi || 0);
};

const diasEmAberto = (task) => {
    const d = dataAbertura(task);
    if (!d) return null;
    const inicio = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    const hoje = new Date(); hoje.setHours(0, 0, 0, 0);
    return Math.max(0, Math.round((hoje - inicio) / 86400000));
};

// --- Tela de Login ---
const LoginScreen = ({ avisoBloqueio }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        try {
            await signInWithEmailAndPassword(auth, email, password);
        } catch (err) {
            switch (err.code) {
                case 'auth/user-not-found': setError('Usuário não encontrado.'); break;
                case 'auth/wrong-password': setError('Senha incorreta.'); break;
                case 'auth/invalid-email': setError('Formato de e-mail inválido.'); break;
                case 'auth/too-many-requests': setError('Muitas tentativas de login. Tente novamente mais tarde.'); break;
                default: setError('Erro ao fazer login. Verifique suas credenciais.'); break;
            }
        }
    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100 p-4">
            <div className="bg-white p-6 sm:p-8 rounded-lg shadow-md w-full max-w-md">
                <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-1 text-center">Chamados Interno Conceito</h2>
                <p className="text-sm text-gray-500 mb-6 text-center">Entre com sua conta</p>
                {avisoBloqueio && (
                    <div className="mb-4 rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">{avisoBloqueio}</div>
                )}
                <form onSubmit={handleLogin} className="space-y-4">
                    <div>
                        <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email</label>
                        <input type="email" id="email" value={email} onChange={(e) => setEmail(e.target.value)}
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm" required />
                    </div>
                    <div>
                        <label htmlFor="password" className="block text-sm font-medium text-gray-700">Senha</label>
                        <input type="password" id="password" value={password} onChange={(e) => setPassword(e.target.value)}
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm" required />
                    </div>
                    {error && <p className="text-red-500 text-sm">{error}</p>}
                    <button type="submit" className="w-full px-4 py-2 bg-blue-600 text-white font-bold rounded-md hover:bg-blue-700 text-sm">Entrar</button>
                </form>
            </div>
        </div>
    );
};

// --- Card do Kanban ---
const KanbanCard = ({ task, onCardClick, onConcluirTask, onChangeStatus, onEditarAtualizacao }) => {
    const [{ isDragging }, drag] = useDrag(() => ({
        type: ItemTypes.CARD,
        item: { id: task.id, status: task.status },
        collect: (monitor) => ({ isDragging: monitor.isDragging() }),
    }), [task.id, task.status]);

    const cor = STATUS_COLORS[task.status] || { bg: 'bg-gray-400', border: 'border-gray-600', text: 'text-white' };
    const textoEscuro = cor.text === 'text-black';

    const getPriorityColor = (priority) => {
        if (priority <= 3) return 'bg-red-700 text-white';
        if (priority <= 7) return 'bg-yellow-600 text-gray-900';
        return 'bg-green-700 text-white';
    };

    // Pisca se o status for "Atualizar" e a data de atualização for hoje
    const shouldBlink = task.status === 'Atualizar' && task.dtAtualizacao === hojeTxt();

    const dias = diasEmAberto(task);
    const corDias = dias == null ? '' : dias >= 15 ? 'bg-red-800 text-white' : dias >= 7 ? 'bg-yellow-300 text-gray-900' : 'bg-white/80 text-gray-800';

    const whatsAppMessage = useMemo(() => {
        const tecnicoName = task.tecnico || "Consultor Sisplan";
        const pendenciaNumber = task.nrPendenciaSequencial || "pendência em aberto";
        return `Olá, tudo bem? Meu nome é ${tecnicoName}, sou consultor da Sisplan. Existe um chamado (Nr: ${pendenciaNumber}) em aberto. Como posso ajudar?`;
    }, [task.tecnico, task.nrPendenciaSequencial]);

    const linkWhats = task.telefoneUsuario
        ? linkWhatsApp(task.telefoneUsuario, whatsAppMessage)
        : null;
    const textoSuave = textoEscuro ? 'text-gray-800' : 'text-white/85';

    return (
        <div
            ref={drag}
            style={{ opacity: isDragging ? 0.5 : 1 }}
            onClick={() => onCardClick(task)}
            title={task.descricao || ''}
            className={`w-full rounded-md shadow-sm hover:shadow-md transition-shadow cursor-pointer border-l-4 ${cor.bg} ${cor.border} ${cor.text} ${shouldBlink ? 'animate-pulse' : ''}`}
        >
            <div className="px-2.5 pt-2 pb-2">
                {task.status === 'Atualizar' && (
                    <button
                        type="button"
                        onClick={(e) => { e.stopPropagation(); onEditarAtualizacao(task); }}
                        className="w-full flex items-center gap-1 text-left text-red-800 bg-white/90 hover:bg-white rounded px-1.5 py-0.5 font-semibold text-[11px] mb-1.5"
                        title="Alterar data e hora da atualização"
                    >
                        <span className="flex-1 min-w-0 truncate">
                            {task.dtAtualizacao && task.horaAtualizacao
                                ? `Atualizar em ${task.dtAtualizacao} às ${task.horaAtualizacao}`
                                : 'Definir data e hora da atualização'}
                        </span>
                        <PencilIcon className="h-3 w-3 flex-shrink-0" />
                    </button>
                )}

                {/* linha 1: empresa · nº · prioridade */}
                <div className="flex items-center gap-1.5">
                    <span className="font-bold text-sm uppercase truncate flex-1 min-w-0" title={task.empresa}>{task.empresa}</span>
                    {task.nrPendenciaSequencial && (
                        <span className="text-[11px] font-bold bg-black/15 rounded px-1.5 py-px flex-shrink-0">#{task.nrPendenciaSequencial}</span>
                    )}
                    {task.prioridade && (
                        <span title="Prioridade" className={`flex-shrink-0 h-5 w-5 rounded-full text-[11px] font-bold flex items-center justify-center ${getPriorityColor(task.prioridade)}`}>
                            {task.prioridade}
                        </span>
                    )}
                </div>

                {/* linha 2: módulo · usuário */}
                <div className={`text-xs mt-1 truncate uppercase ${textoSuave}`}>
                    <CubeIcon className="h-3 w-3 inline-block mr-1 -mt-0.5" />{task.modulo || '—'}
                    <span className="mx-1">·</span>
                    <UserIcon className="h-3 w-3 inline-block mr-1 -mt-0.5" />{task.usuario}{task.setor ? ` (${task.setor})` : ''}
                </div>

                {/* linha 3: telefone · técnico */}
                <div className={`text-xs mt-0.5 flex items-center gap-1 min-w-0 ${textoSuave}`}>
                    {linkWhats && (
                        <a
                            href={linkWhats}
                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); abrirWhatsApp(task.telefoneUsuario, whatsAppMessage); }}
                            className={`inline-flex items-center hover:underline flex-shrink-0 ${textoEscuro ? 'text-blue-900' : 'text-white'}`}
                            title="Abrir conversa no WhatsApp"
                        >
                            <WhatsAppIcon />{task.telefoneUsuario}
                        </a>
                    )}
                    <span className="truncate ml-auto font-semibold" title={`Técnico: ${task.tecnico || ''}`}>{task.tecnico}</span>
                </div>

                {/* linha 4: data · dias em aberto · chamado */}
                <div className="text-[11px] mt-1 flex items-center gap-1.5 flex-wrap">
                    <span className={`inline-flex items-center ${textoSuave}`}>
                        <ClockIcon className="h-3 w-3 mr-1" />{task.dtLancamento} {task.hora}
                    </span>
                    {dias != null && (
                        <span title="Dias em aberto" className={`font-bold rounded-full px-1.5 py-px ${corDias}`}>
                            {dias === 0 ? 'hoje' : `${dias}d`}
                        </span>
                    )}
                    {task.chamado && <span className="ml-auto font-bold">Ch. {task.chamado}</span>}
                </div>

                {/* linha 5: status + concluir */}
                <div className="flex items-center gap-1.5 mt-2">
                    <select
                        value={task.status}
                        onClick={(e) => e.stopPropagation()}
                        onChange={(e) => { e.stopPropagation(); onChangeStatus(task.id, e.target.value); }}
                        className="flex-1 min-w-0 h-7 rounded border border-black/10 bg-white/90 text-gray-800 text-xs px-1.5 focus:outline-none focus:ring-2 focus:ring-white/70"
                    >
                        {COLUNAS.map((s) => <option key={s} value={s}>{s}</option>)}
                    </select>
                    <button
                        onClick={(e) => { e.stopPropagation(); onConcluirTask(task.id); }}
                        className="h-7 px-2 xl:px-2.5 bg-green-700 hover:bg-green-800 text-white text-xs font-bold rounded flex-shrink-0"
                        title="Concluir pendência"
                    >
                        ✓<span className="hidden 2xl:inline"> Concluir</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

// --- Modal de Data e Hora de Atualização ---
// dataInicial (dd/mm/aaaa) e horaInicial (hh:mm) vêm preenchidas quando é edição de uma atualização já agendada
const UpdateDateTimeModal = ({ isOpen, onClose, onConfirm, dataInicial, horaInicial }) => {
    const [date, setDate] = useState('');
    const [time, setTime] = useState('');

    useEffect(() => {
        if (isOpen) {
            const now = new Date();
            const p = (n) => String(n).padStart(2, '0');
            const [d, m, a] = (dataInicial || '').split('/');
            setDate(a && m && d ? `${a}-${m}-${d}` : `${now.getFullYear()}-${p(now.getMonth() + 1)}-${p(now.getDate())}`);
            setTime(horaInicial ? horaInicial.slice(0, 5) : `${p(now.getHours())}:${p(now.getMinutes())}`);
        }
    }, [isOpen, dataInicial, horaInicial]);

    const handleConfirm = () => {
        if (date && time) {
            const [year, month, day] = date.split('-');
            onConfirm(`${day}/${month}/${year}`, time, new Date(`${date}T${time}:00`));
        } else {
            alert('Por favor, selecione a data e a hora.');
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-sm">
                <h3 className="text-lg font-semibold mb-4 text-gray-800">Informar Data e Hora de Atualização</h3>
                <div className="space-y-4">
                    <div>
                        <label htmlFor="updateDate" className="block text-sm font-medium text-gray-700">Data:</label>
                        <input type="date" id="updateDate" value={date} onChange={(e) => setDate(e.target.value)}
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500" required />
                    </div>
                    <div>
                        <label htmlFor="updateTime" className="block text-sm font-medium text-gray-700">Hora:</label>
                        <input type="time" id="updateTime" value={time} onChange={(e) => setTime(e.target.value)}
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500" required />
                    </div>
                </div>
                <div className="flex justify-end space-x-3 mt-6">
                    <button onClick={onClose} className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400">Cancelar</button>
                    <button onClick={handleConfirm} className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700">Confirmar</button>
                </div>
            </div>
        </div>
    );
};

// --- Coluna do Kanban (área onde os cards são soltos) ---
const KanbanColumn = ({ tasks, status, moveCard, onCardClick, onConcluirTask, onChangeStatus, onRequireDateTime, onEditarAtualizacao }) => {
    const [{ isOver }, drop] = useDrop(() => ({
        accept: ItemTypes.CARD,
        drop: (item) => {
            if (item.status === status) return;
            if (status === 'Atualizar') onRequireDateTime(item.id, status);
            else moveCard(item.id, status);
        },
        collect: (monitor) => ({ isOver: monitor.isOver() }),
    }), [status, moveCard, onRequireDateTime]);

    return (
        <div ref={drop} className={`${LARGURA_COLUNA} rounded-lg space-y-2 min-h-[60vh] p-1 -m-1 transition-colors ${isOver ? 'bg-gray-300' : ''}`}>
            {tasks.map((task) => (
                <KanbanCard key={task.id} task={task} onCardClick={onCardClick} onConcluirTask={onConcluirTask} onChangeStatus={onChangeStatus} onEditarAtualizacao={onEditarAtualizacao} />
            ))}
        </div>
    );
};

// --- Quadro Kanban ---
const KanbanBoard = ({ tasks, currentUser, selectedTecnico, busca, onCardClick }) => {
    const tasksRef = useRef(tasks);
    const [modal, setModal] = useState(null); // { taskId, status, dataInicial?, horaInicial? }

    useEffect(() => { tasksRef.current = tasks; }, [tasks]);

    const moveCard = useCallback(async (id, newStatus, additionalData = {}) => {
        const oldTask = tasksRef.current.find(t => t.id === id);
        if (!oldTask) {
            alert("A pendência não foi encontrada. Atualize a página e tente de novo.");
            return;
        }

        if (newStatus === 'Ag. Pendencia' && (!oldTask.chamado || oldTask.chamado.trim() === '' || oldTask.chamado === '0')) {
            alert("Não é possível mover para 'Ag. Pendencia' sem um número de pendência (Chamado) válido. Por favor, edite a pendência e informe o número do chamado.");
            return;
        }

        try {
            // a API grava o status, o histórico e a data de conclusão numa única operação
            await api.post(`/pendencias/${id}/status`, {
                status: newStatus,
                dtAtualizacao: additionalData.dtAtualizacao ?? null,
                horaAtualizacao: additionalData.horaAtualizacao ?? null,
                atualizarEm: additionalData.timestampAtualizacao ? additionalData.timestampAtualizacao.toISOString() : null,
            });
            recarregar('pendencias');
        } catch (error) {
            console.error("Erro ao mover card:", error);
            alert(error.message || "Erro ao salvar a alteração no servidor. Tente novamente.");
        }
    }, [currentUser]);

    const handleConcluirTask = (taskId) => {
        const t = tasks.find(x => x.id === taskId);
        if (!t || t.status === 'Concluído') return;
        if (window.confirm(`Concluir a pendência ${t.nrPendenciaSequencial || ''} (${t.empresa})?`)) moveCard(taskId, 'Concluído');
    };

    const handleRequireDateTime = useCallback((taskId, status) => setModal({ taskId, status }), []);

    // card já em "Atualizar": reabre o modal com a data/hora gravadas para alterar
    const handleEditarAtualizacao = useCallback((task) => setModal({
        taskId: task.id, status: 'Atualizar', dataInicial: task.dtAtualizacao, horaInicial: task.horaAtualizacao,
    }), []);

    // troca de status pelo seletor do card
    const handleChangeStatus = (taskId, status) => {
        if (status === 'Atualizar') handleRequireDateTime(taskId, status);
        else moveCard(taskId, status);
    };

    const handleModalConfirm = (date, time, dataHora) => {
        if (modal) moveCard(modal.taskId, modal.status, { dtAtualizacao: date, horaAtualizacao: time, timestampAtualizacao: dataHora });
        setModal(null);
    };

    // filtros: técnico + busca por empresa, nº da pendência, nº do chamado, usuário ou módulo
    const termo = normalizar(busca).trim();
    const filtradas = tasks.filter(t => {
        if (selectedTecnico && t.tecnico !== selectedTecnico) return false;
        if (!termo) return true;
        return [t.empresa, t.nrPendenciaSequencial, t.chamado, t.usuario, t.modulo, t.descricao]
            .some(v => normalizar(v).includes(termo));
    });
    const porPrioridade = (a, b) => (a.prioridade || 99) - (b.prioridade || 99) || (a.nrPendenciaSequencial || 0) - (b.nrPendenciaSequencial || 0);
    const colunas = COLUNAS.map((status) => ({
        status,
        tasks: filtradas.filter(t => t.status === status).sort(porPrioridade),
    }));

    return (
        <div className="flex-1 overflow-auto">
            <div className="inline-flex flex-col min-w-full">
                {/* títulos das colunas + busca, filtro e botão */}
                <div className="sticky top-0 z-10 bg-gray-200 flex items-center gap-2 xl:gap-4 px-2 sm:px-3 xl:px-5 py-2 border-b border-gray-300">
                    {colunas.map(({ status, tasks: lista }) => (
                        <h3 key={status} title={status} className={`${LARGURA_COLUNA} flex items-center gap-1.5 xl:gap-2 text-sm xl:text-base font-bold text-gray-700 whitespace-nowrap min-w-0`}>
                            <span className={`inline-block w-2.5 h-2.5 rounded-full flex-shrink-0 ${STATUS_COLORS[status].bg}`} />
                            <span className="truncate">{status}</span>
                            <span className="text-xs font-semibold bg-white text-gray-600 rounded-full px-2 py-0.5 flex-shrink-0">{lista.length}</span>
                        </h3>
                    ))}
                </div>

                {/* cards */}
                <div className="flex gap-2 xl:gap-4 px-2 sm:px-3 xl:px-5 py-3 items-start">
                    {colunas.map(({ status, tasks: lista }) => (
                        <KanbanColumn
                            key={status}
                            status={status}
                            tasks={lista}
                            moveCard={moveCard}
                            onCardClick={onCardClick}
                            onConcluirTask={handleConcluirTask}
                            onChangeStatus={handleChangeStatus}
                            onRequireDateTime={handleRequireDateTime}
                            onEditarAtualizacao={handleEditarAtualizacao}
                        />
                    ))}
                </div>
            </div>

            <UpdateDateTimeModal isOpen={!!modal} onClose={() => setModal(null)} onConfirm={handleModalConfirm}
                dataInicial={modal?.dataInicial} horaInicial={modal?.horaInicial} />
        </div>
    );
};

// --- Tela de Pendências ---
const PendenciasView = ({ onNavigate, tasks, currentUser, consultores }) => {
    const [selectedTecnico, setSelectedTecnico] = useState('');
    const [busca, setBusca] = useState('');

    const controles = (
        <>
            <div className="relative flex-1 md:flex-none">
                <SearchIcon className="h-4 w-4 absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                    type="text"
                    value={busca}
                    onChange={(e) => setBusca(e.target.value)}
                    placeholder="Buscar empresa, nº, chamado..."
                    className="w-full md:w-56 pl-8 pr-7 py-2 border border-gray-300 rounded-md shadow-sm text-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-400"
                />
                {busca && (
                    <button onClick={() => setBusca('')} className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-700 text-lg leading-none" title="Limpar">×</button>
                )}
            </div>
            <BuscaSelect
                className="flex-1 md:flex-none md:w-56"
                placeholder="Todos os técnicos"
                vazio="Nenhum técnico encontrado"
                valor={selectedTecnico}
                onChange={setSelectedTecnico}
                opcoes={consultores.map((c) => ({ valor: c.nome, rotulo: c.nome || '', detalhe: c.ativo === false ? 'inativo' : '' }))}
            />
            <button
                onClick={() => onNavigate('pendencia_cadastro')}
                className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 text-sm whitespace-nowrap shadow-sm"
            >
                + Nova Pendência
            </button>
        </>
    );

    return (
        <div className="h-full flex flex-col">
            {/* barra fixa com busca, filtro e botão: não rola junto com o quadro, então nunca sai da tela */}
            <div className="flex-shrink-0 flex flex-wrap items-center gap-2 px-2 sm:px-3 xl:px-5 pt-3 pb-1">
                <span className="hidden lg:inline text-sm text-gray-600 mr-auto">
                    {tasks.length} pendência{tasks.length === 1 ? '' : 's'} em aberto
                </span>
                <div className="flex flex-wrap items-center gap-2 w-full lg:w-auto">{controles}</div>
            </div>
            <KanbanBoard
                tasks={tasks}
                currentUser={currentUser}
                selectedTecnico={selectedTecnico}
                busca={busca}
                onCardClick={(task) => onNavigate('pendencia_cadastro', task)}
            />
        </div>
    );
};

// --- App ---
function App() {
    // ?importar no endereço abre a tela de importação do Firebase
    const [currentView, setCurrentView] = useState(() => (typeof window !== 'undefined' && /[?&]importar\b/.test(window.location.search) ? 'importar' : 'pendencias'));
    const [editingItemData, setEditingItemData] = useState(null);
    const [preselectedCompanyId, setPreselectedCompanyId] = useState(null);
    const [newlyCreatedUser, setNewlyCreatedUser] = useState(null);

    const [currentUser, setCurrentUser] = useState(null);
    const [loadingAuth, setLoadingAuth] = useState(true);
    const [avisoBloqueio, setAvisoBloqueio] = useState('');
    const [souAdmin, setSouAdmin] = useState(false); // admin: vê e usa os cadastros (consultores, empresas, módulos)

    // listas vindas da API (Firebird), atualizadas em tempo real
    const logado = !!currentUser;
    const { dados: consultores } = useColecao('consultores', logado);
    // técnicos para listas e filtros: sem quem é "somente acesso" (ex.: sócio)
    const tecnicos = useMemo(() => consultores.filter((c) => !c.soAcesso), [consultores]);
    const { dados: empresas } = useColecao('empresas', logado);
    const { dados: usuarios } = useColecao('usuarios', logado);
    const { dados: tasks, carregando: carregandoTasks } = useColecao('pendencias', logado);
    const { dados: modulos } = useColecao('modulos', logado);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (user) {
                // confere no servidor se o acesso não foi bloqueado (consultor inativo) antes de abrir o sistema
                try {
                    const eu = await api.get('/eu');
                    setSouAdmin(!!eu.admin);
                } catch (e) {
                    if (e.status === 403) return; // o aviso de bloqueio encerra a sessão (ver abaixo)
                    // outros erros (servidor fora do ar etc.) não impedem a entrada; as telas mostram o problema
                }
                setAvisoBloqueio('');
                iniciarDados();
            }
            setCurrentUser(user);
            setLoadingAuth(false);
        });
        return () => unsubscribe();
    }, []);

    // o perfil (admin ou não) pode mudar quando alguém altera o cadastro de consultores: confere de novo
    useEffect(() => {
        if (!currentUser) { setSouAdmin(false); return undefined; }
        let vivo = true;
        api.get('/eu').then((eu) => { if (vivo) setSouAdmin(!!eu.admin); }).catch(() => {});
        return () => { vivo = false; };
    }, [currentUser, consultores]);

    // quem deixou de ser admin e está numa tela de cadastro volta para as pendências
    const VIEWS_ADMIN = ['consultor', 'empresas', 'modulos', 'usuario_cadastro'];
    useEffect(() => {
        if (currentUser && !souAdmin && VIEWS_ADMIN.includes(currentView)) setCurrentView('pendencias');
    }, [currentUser, souAdmin, currentView]); // eslint-disable-line react-hooks/exhaustive-deps

    // título da aba do navegador: quantidade de pendências em aberto (todos os status do quadro).
    // Atualiza sozinho quando alguém cria, conclui ou reabre uma pendência.
    useEffect(() => {
        const base = 'Chamados Conceito';
        document.title = currentUser && !carregandoTasks ? `(${tasks.length}) ${base}` : base;
    }, [currentUser, carregandoTasks, tasks.length]);

    // consultor inativado: sai do sistema na hora e mostra o motivo na tela de login
    useEffect(() => {
        const aoBloquear = (ev) => {
            encerrarDados();
            setAvisoBloqueio(ev.detail || 'Seu acesso ao sistema foi bloqueado.');
            setCurrentView('pendencias');
            signOut(auth).catch(() => {});
            setCurrentUser(null);
            setLoadingAuth(false);
        };
        window.addEventListener(EVENTO_BLOQUEIO, aoBloquear);
        return () => window.removeEventListener(EVENTO_BLOQUEIO, aoBloquear);
    }, []);

    const handleNavigation = useCallback((view, itemToEdit = null, companyIdToPreselect = null, newlyCreatedUserData = null) => {
        setEditingItemData(itemToEdit);
        setPreselectedCompanyId(companyIdToPreselect);
        setNewlyCreatedUser(newlyCreatedUserData);
        setCurrentView(view);
    }, []);

    const onDeletePendencia = useCallback(async (pendenciaIdFirebase) => {
        try {
            await api.del(`/pendencias/${pendenciaIdFirebase}`);
            recarregar('pendencias');
            alert('Pendência excluída com sucesso!');
            setCurrentView('pendencias');
        } catch (error) {
            console.error("Erro ao excluir pendência:", error);
            alert(`Erro ao excluir a pendência: ${error.message}`);
        }
    }, []);

    const onDeleteUsuario = useCallback(async (usuarioIdFirebase) => {
        try {
            // o servidor recusa se o usuário estiver em alguma pendência e devolve o motivo
            await api.del(`/usuarios/${usuarioIdFirebase}`);
            recarregar('usuarios');
            alert('Usuário excluído com sucesso!');
            handleNavigation('usuario_cadastro', null, preselectedCompanyId);
        } catch (error) {
            console.error("Erro ao excluir usuário:", error);
            alert(error.message);
        }
    }, [preselectedCompanyId, handleNavigation]);

    const handleLogout = async () => {
        try {
            encerrarDados();
            await signOut(auth);
            setCurrentView('pendencias');
        } catch (error) {
            console.error("Erro ao fazer logout:", error);
            alert("Erro ao fazer logout.");
        }
    };

    // o cadastro de pendência e o de usuário acendem a aba "Pendências"
    const abaAtiva = ['pendencia_cadastro', 'usuario_cadastro'].includes(currentView) ? 'pendencias' : currentView;

    const renderView = () => {
        if (VIEWS_ADMIN.includes(currentView) && !souAdmin) {
            return <div className="p-6 text-center text-gray-600">Somente administradores acessam os cadastros.</div>;
        }
        switch (currentView) {
            case 'pendencias':
                return <PendenciasView onNavigate={handleNavigation} tasks={tasks} currentUser={currentUser} consultores={tecnicos} />;
            case 'calendario':
                return <CalendarioView tasks={tasks} consultores={tecnicos} onOpenTask={(task) => handleNavigation('pendencia_cadastro', task)} />;
            case 'consultor':
                return <ConsultorCadastro consultores={consultores} currentUser={currentUser} setCurrentView={handleNavigation} />;
            case 'empresas':
                return <EmpresaCadastro empresas={empresas} usuarios={usuarios} currentUser={currentUser} setCurrentView={handleNavigation} onCompanyCreated={() => {}} />;
            case 'pendencia_cadastro':
                return (
                    <PendenciaCadastro
                        empresas={empresas}
                        usuarios={usuarios}
                        consultores={consultores}
                        modulos={modulos}
                        initialData={editingItemData}
                        setCurrentView={handleNavigation}
                        currentUser={currentUser}
                        onDeletePendencia={onDeletePendencia}
                        newlyCreatedUser={newlyCreatedUser}
                        clearNewlyCreatedUser={() => setNewlyCreatedUser(null)}
                        souAdmin={souAdmin}
                    />
                );
            case 'modulos':
                return <ModuloCadastro modulos={modulos} tasks={tasks} currentUser={currentUser} setCurrentView={handleNavigation} />;
            case 'usuario_cadastro':
                return (
                    <UsuarioCadastro
                        empresas={empresas}
                        usuarios={usuarios}
                        currentUser={currentUser}
                        setCurrentView={handleNavigation}
                        preselectedCompanyId={preselectedCompanyId}
                        initialData={editingItemData}
                        onUserCreated={(userData) => {
                            setNewlyCreatedUser(userData);
                            handleNavigation('pendencia_cadastro', null, null, userData);
                        }}
                        onDeleteUsuario={onDeleteUsuario}
                    />
                );
            case 'pendencias_concluidas':
                return (
                    <PendenciasConcluidasView
                        empresas={empresas}
                        usuarios={usuarios}
                        consultores={tecnicos}
                        modulos={modulos}
                        onViewPendency={handleNavigation}
                        setCurrentView={handleNavigation}
                    />
                );
            case 'dashboard':
                return (
                    <DashboardConcluidas
                        tasks={tasks}
                        consultores={tecnicos}
                        onViewPendency={handleNavigation}
                    />
                );
            case 'importar':
                return <ImportarFirebase onVoltar={() => { window.history.replaceState(null, '', window.location.pathname); setCurrentView('pendencias'); }} />;
            default:
                return <div>Página não encontrada</div>;
        }
    };

    if (loadingAuth) {
        return <div className="flex justify-center items-center h-screen text-xl text-gray-700">Carregando autenticação...</div>;
    }
    if (!currentUser) return <LoginScreen avisoBloqueio={avisoBloqueio} />;

    return (
        <DndProvider backend={HTML5Backend}>
            <div className="flex flex-col h-screen bg-gray-200 font-sans">
                {/* ---- topo: título | abas | usuário e sair ---- */}
                <header className="bg-white shadow-sm flex-shrink-0">
                    <div className="flex flex-wrap xl:flex-nowrap items-end gap-x-4 2xl:gap-x-6 px-3 sm:px-4 2xl:px-6">
                        <button
                            onClick={() => handleNavigation('pendencias')}
                            className="text-lg 2xl:text-xl font-bold text-gray-800 whitespace-nowrap py-2.5 xl:py-3 2xl:py-4 self-center"
                        >
                            Chamados Interno Conceito
                        </button>

                        <div className="xl:order-last ml-auto flex items-center gap-3 text-sm text-gray-600 py-2 self-center flex-shrink-0">
                            <span className="hidden 2xl:inline whitespace-nowrap">
                                Logado como: <span className="font-semibold text-gray-800">{currentUser.email}</span>
                            </span>
                            <button
                                onClick={handleLogout}
                                title={currentUser.email}
                                className="flex items-center gap-2 px-3 2xl:px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-md shadow-sm whitespace-nowrap"
                            >
                                <LogoutIcon className="h-5 w-5" /> Sair
                            </button>
                        </div>

                        {/* as abas quebram para a linha de baixo quando não cabem (antes ficavam escondidas) */}
                        <nav className="w-full xl:w-auto xl:flex-1 min-w-0 flex flex-wrap gap-y-1">
                            {TABS.filter((t) => !t.soAdmin || souAdmin).map(({ view, label, Icon }) => {
                                const ativa = abaAtiva === view;
                                return (
                                    <button
                                        key={view}
                                        onClick={() => handleNavigation(view)}
                                        className={`flex items-center gap-1.5 2xl:gap-2 px-2.5 2xl:px-4 py-2 2xl:py-2.5 mr-1 text-sm whitespace-nowrap rounded-t-md border-b-2 transition-colors ${
                                            ativa
                                                ? 'bg-white border-blue-600 text-gray-900 font-semibold'
                                                : 'bg-gray-100 border-transparent text-gray-700 hover:bg-gray-200'
                                        }`}
                                    >
                                        <Icon className="h-4 w-4 2xl:h-5 2xl:w-5 flex-shrink-0" />
                                        {label}
                                    </button>
                                );
                            })}
                        </nav>
                    </div>
                </header>

                {/* ---- conteúdo ---- */}
                <main className="flex-1 min-h-0 overflow-hidden flex flex-col">
                    {currentView === 'pendencias' ? (
                        renderView()
                    ) : (
                        <div className="flex-1 overflow-y-auto p-3 sm:p-4 2xl:p-6">{renderView()}</div>
                    )}
                </main>
            </div>
        </DndProvider>
    );
}

export default App;
